import React from "react";
import PropTypes from "prop-types";
import { Grid, TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { displayOccurrenceContext } from "./occurrenceDisplay";

export default function OccurrenceContextFields({
  teacher,
  course,
  stage,
  type
}) {
  const { t } = useTranslation();
  return (
    <>
      <Grid item xs={12}>
        <TextField
          name="stage"
          id="stage"
          label={t("common.labels.stage")}
          value={displayOccurrenceContext(stage)}
          fullWidth
          disabled
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          name="type"
          id="type"
          label={t("common.labels.type")}
          value={displayOccurrenceContext(type)}
          fullWidth
          disabled
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          name="teacher"
          id="teacher"
          label={t("common.labels.teacher")}
          value={displayOccurrenceContext(teacher)}
          fullWidth
          disabled
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          name="course"
          id="course"
          label={t("common.labels.discipline")}
          value={displayOccurrenceContext(course)}
          fullWidth
          disabled
        />
      </Grid>
    </>
  );
}

OccurrenceContextFields.propTypes = {
  teacher: PropTypes.string,
  course: PropTypes.string,
  stage: PropTypes.string,
  type: PropTypes.string
};

OccurrenceContextFields.defaultProps = {
  teacher: "",
  course: "",
  stage: "",
  type: ""
};
